<template>
  <div class="form-group theme-payment-page-form-item">
    <i class="fa fa-angle-down"></i>
    <select
      v-model="modelField"
      @change="$emit('handleCreditcard', $event.target)"
      :name="name"
      :class="{ 'alert-danger': !validation }"
      class="form-control">
      <option value="">Selecione o cartão de crédito*</option>
      <option
        v-for="creditcard in creditcards"
        :key="creditcard.id"
        :value="creditcard.id">
        {{ creditcard.name }} **** **** **** {{ creditcard.partial_number }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  inject: [ '$validator' ],
  props: [
    'validation',
    'name',
    'creditcards'
  ],
  data () {
    return {
      modelField: ''
    }
  }
}
</script>
